// FA — the product language. One flat map, composed from one module per
// namespace.
//
// ── Why the split exists ─────────────────────────────────────────────────
//
// This catalogue was a single 600-line map, and a single map is a file two
// people cannot write at the same time: the patients screen, the chat page and
// the visit workspace are being built in parallel, and every one of them adds
// copy. Two authors appending to one object produce a conflict on every hunk,
// and the resolution — «keep both» — is exactly where a duplicate key or a lost
// line comes from. So the copy now lives in ./fa/<namespace>.js, ONE FILE PER
// NAMESPACE, and this file only merges them. An author owns a namespace, edits
// that file alone, and never touches a line another author wrote. ./fa/chat.js
// and ./fa/visit.js in particular belong to the chat and visit authors; nothing
// else may add keys to them.
//
// The EXPORTED SHAPE is unchanged: `fa` is still the flat, fully-qualified,
// dotted-key map that catalogs.js, translator.js and tests/i18n.test.js consume.
// Nothing downstream knows the split happened.
//
// Every key here must exist in en.js (EN is the source catalogue) and every EN
// key must be translated here; tests/i18n.test.js asserts both directions.
//
// The `practice.*` lines and the assistant's disclaimer are the copy core.md
// §3.1 calls non-negotiable, and Persian is the language it names: this is the
// text a student actually reads before they act on a model's answer. Do not
// soften it.

import { common } from './fa/common.js';
import { nav } from './fa/nav.js';
import { login } from './fa/login.js';
import { onboarding } from './fa/onboarding.js';
import { patients } from './fa/patients.js';
import { record } from './fa/record.js';
import { chat } from './fa/chat.js';
import { visit } from './fa/visit.js';
import { credits } from './fa/credits.js';
import { profile } from './fa/profile.js';
import { errors } from './fa/errors.js';

export const fa = {
  ...common,
  ...nav,
  ...login,
  ...onboarding,
  ...patients,
  ...record,
  ...chat,
  ...visit,
  ...credits,
  ...profile,
  ...errors,
};

export default fa;
